import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getPrescriptionService } from '../../../domains/prescriptions';

interface UpdateStatusInput {
  orderId: number | string;
  status: string;
  additional?: Record<string, any>;
}

/**
 * 주문(처방전) 상태 변경 mutation.
 * 성공 시 관련 쿼리(orders, last-prescription, ai-insight, substitutions) invalidate.
 */
export const useUpdateOrderStatus = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ orderId, status, additional = {} }: UpdateStatusInput) => {
      return await getPrescriptionService().updateOrderStatus(orderId, { status, ...additional });
    },
    onSuccess: () => {
      // 주문 리스트 + 관련 detail 캐시 무효화
      qc.invalidateQueries({ queryKey: ['ai-insight'] });
      qc.invalidateQueries({ queryKey: ['substitutions'] });
      qc.invalidateQueries({ queryKey: ['last-prescription'] });
      qc.invalidateQueries({ queryKey: ['user-prescriptions'] });
    },
  });
};
